import {ImgZoom, MediaImage} from './components_index.js';
import {Link} from 'react-router-dom';
import "../styles/Person.css";
// import { useMediaUrl } from '../hooks/hooks_index.js';

export default function InfoBox({person, image_infos, people, clickable=true}) {
  return (
    <table className='infobox'>
      <tbody className='infobox-body'>
        <tr>
          <th colSpan='2' className='infobox-name'>
            {person.AKA || person.f_name+' '+person.l_name}
          </th>
        </tr>
        <tr>
          <td colSpan='2' className='infobox-img'>
            {!clickable && 
              <MediaImage mediaID={person.profile_pic} alt={image_infos[person.profile_pic]?.subtext ?? ""}/>
            }
            {clickable && 
              <ImgZoom src={person.profile_pic} alt={image_infos[person.profile_pic]?.subtext ?? ""} bioPic={true}/>
            }
          </td>
        </tr>
        <tr>
          <td colSpan='2' className='infobox-img-details'>
            {image_infos[person.profile_pic]?.subtext ?? ""}
          </td>
        </tr>
        <tr>
          <td colSpan='2' className='infobox-details'>
            Personal Details
          </td>
        </tr>
        {/* <VarRow row_title={'Born'} row_val={[person.b_details, !person.d_details && 'alive']} /> */}
        {person.b_details && <VarRow row_title={'Born'} row_val={[person.b_details, !person.d_details && 'alive']} />}
        {person.nicknames && <VarRow row_title={'Nicknames'} row_val={person.nicknames}/>}
        {person.parents && <VarRow row_title={'Parents'} row_val={person.parents} people={people} />}
        {person.d_details && <VarRow row_title={'Died'} row_val={[person.d_details, person.b_details]} />}
        {person.siblings && <VarRow row_title={'Siblings'} row_val={person.siblings} people={people} />}
        {person.m_details && <VarRow row_title={(person.m_details.length > 1) ? 'Spouses' : 'Spouse'} row_val={person.m_details} people={people} />}
        {person.children && <VarRow row_title={'Children'} row_val={person.children} people={people}/>}
        {person.email && <VarRow row_title={'Email'} row_val={person.email} />}
        {person.phone &&<VarRow row_title={'Phone #'} row_val={person.phone} />}
        {person.address && <VarRow row_title={'Address'} row_val={person.address} />}
      </tbody>
    </table>
  );
}

function VarRow({row_title, row_val, people}) {
  let row_data;
  // let personLookup;
  // personLookup = (id) => NameChanger(id, people);

  if (row_title === "Born") {
    const date = new Date(row_val[0].b_year, row_val[0].b_month-1, row_val[0].b_day);
    const today = new Date();
    const age =
      today.getFullYear() -
      date.getFullYear() -
      (today < new Date(today.getFullYear(), date.getMonth(), date.getDate()) ? 1 : 0);
    const formatted = date.toLocaleDateString("en-US", {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
    row_data = (
      <ul>
        {row_val[0].f_name && (
          <li>
            <div className='infobox-dataitem'>
              {row_val[0].f_name} {row_val[0].m_name && row_val[0].m_name} {row_val[0].l_name}
            </div>
          </li>
        )}
        <li>
          <div className='infobox-dataitem'>
            {formatted} {(row_val[1] === 'alive')? '(Age '+age+')': ""}
          </div>
        </li>
        <li>
          <div className='infobox-dataitem'>   {/*May need to adjust if state and or city is unknown*/}
            {row_val[0].b_city}, {row_val[0].b_state}
          </div>
        </li>
      </ul>
    );
  } else if (row_title === "Died") {
    const {d_year, d_month, d_day} = row_val[0]
    let formatted = '';
    let date = null;

    if (d_year) {
      const options = {};
      if (d_month) options.month = 'long';
      if (d_day) options.day = 'numeric';
      options.year = 'numeric';

      date = new Date(
        d_year,
        d_month ? d_month - 1 : 0,
        d_day || 1
      );
      formatted = date.toLocaleDateString('en-US', options);
    }
    let age = 0 
    if (row_val[1]) {
      const b_date = new Date(row_val[1].b_year, row_val[1].b_month-1, row_val[1].b_day);
      age =
        date.getFullYear() -
        b_date.getFullYear() -
        (date < new Date(date.getFullYear(), b_date.getMonth(), b_date.getDate()) ? 1 : 0);
    }
    row_data = (
      <ul>
        <li>        
          <div className='infobox-dataitem'>
            {formatted}{row_val[1] && ` (Age ${age})`}
          </div>
        </li>
        {row_val[0].d_state &&
          <li>
            <div className='infobox-dataitem'>
              {row_val[0].d_city}, {row_val[0].d_state}
            </div>
          </li>
        }
      </ul>
    );
  } else if (row_title === "Spouse" || row_title === "Spouses") {
    row_data = (
      <ul>
        {row_val.map((val, index) => (
          <div key={index}>
            <li>
              {(people[val.spouse]) ?
                <Link to={`/people/${val.spouse}`} className='infobox-dataitem'>
                  {people[val.spouse].AKA || people[val.spouse].f_name+' '+people[val.spouse].l_name}
                </Link>
                :
                <div className='infobox-dataitem'>{val.spouse}</div>
              }
            </li>
            <li>
              <div className={`infobox-dataitem${index < row_val.length - 1 ? " spouse" : ""}`}>
                (m. {val.m_year}
                  {val.div_year && (
                    <>
                      ; div. {val.div_year}
                    </>
                  )})
              </div>
            </li>
          </div>
        ))}
      </ul>
    );
  } else if (row_title === "Nicknames") {
    row_data = (
      <ul>
        {row_val.map((val, index) => (
          <li key={index}>
            <div className='infobox-dataitem'>{val}</div>
          </li>
        ))}
      </ul>
    );
  } else if (Array.isArray(row_val)) {
    row_data = (
      <ul>
        {row_val.map((val, index) => (
          <li key={index}>
            {(people[val]) ?
              <Link to={`/people/${val}`} className='infobox-dataitem'>
                {people[val].AKA || people[val].f_name+' '+people[val].l_name}
              </Link>
              :
              <div className='infobox-dataitem'>{val}</div>
            }
          </li>
        ))}
      </ul>
    );
  } else if (row_title === "Address") {
    const addressList = row_val.formattedAddress.split(",").map(part => part ?? "");
    row_data = (
      <ul>
        {(addressList[0] !== "" && addressList[0] !== " ") &&
          <li>
            {addressList[0]}
          </li>
        }
        {(addressList[1] !== "" && addressList[1] !== " ") &&
          <li>
            {addressList[1]}
          </li>
        }
        <li>
          {addressList[2]}, {addressList[3]?.replace(/\b(undefined|null)\b/g, "")}
        </li>
      </ul>
      // <ul>
      //   <li>
      //     {(people[row_val.f_id]) ?
      //       <Link to={`/people/${row_val.f_id}`} className='infobox-dataitem'>
      //         {people[row_val.f_id].AKA || people[row_val.f_id].f_name+' '+people[row_val.f_id].l_name}
      //       </Link>
      //       :
      //       <div className='infobox-dataitem'>{row_val.f_id}</div>
      //     }
      //   </li>
      //   <li>
      //     {(people[row_val.m_id]) ?
      //       <Link to={`/people/${row_val.m_id}`} className='infobox-dataitem'>
      //         {people[row_val.m_id].AKA || people[row_val.m_id].f_name+' '+people[row_val.m_id].l_name}
      //       </Link>
      //       :
      //       <div className='infobox-dataitem'>{row_val.m_id}</div>
      //     }
      //   </li>
      // </ul>
    )
  } else if (typeof row_val === 'object'){
    row_data = (
      <ul>
        <li>
          {(people[row_val.f_id]) ?
            <Link to={`/people/${row_val.f_id}`} className='infobox-dataitem'>
              {people[row_val.f_id].AKA || people[row_val.f_id].f_name+' '+people[row_val.f_id].l_name}
            </Link>
            :
            <div className='infobox-dataitem'>{row_val.f_id}</div>
          }
        </li>
        <li>
          {(people[row_val.m_id]) ?
            <Link to={`/people/${row_val.m_id}`} className='infobox-dataitem'>
              {people[row_val.m_id].AKA || people[row_val.m_id].f_name+' '+people[row_val.m_id].l_name}
            </Link>
            :
            <div className='infobox-dataitem'>{row_val.m_id}</div>
          }
        </li>
      </ul>
    )
  } else {
    row_data = (
      <ul>
        <li>
          <div className='infobox-dataitem'>
            {row_val}
          </div>
        </li>
      </ul>
    )
  }

  return (
    <tr>
      <th scope='row' className='infobox-label'>{row_title}</th>
      <td className='infobox-data'>
        <div className='infobox-datalist'>
          {row_data}
        </div>
      </td>
    </tr>
  )
}